import request from '@/utils/request'
import jsonRequest from '@/utils/jsonRequest'


export function getJSON(url) {
  return jsonRequest({
    url: url
  });
}

// 获取全部书房
export function getAllLibraryName() {
    return request({
      url: '/app/study/getAllLibraryName',
      method: 'get',
    })
  }


// 获取书房详情
export function getLibrary(id) {
    return request({
      url: '/app/study/getLibrary/'+id,
      method: 'get',
    })
  }

// 获取通知公告
export function getLibraryDynamicsPage(data) {
    return request({
      url: '/app/study/getLibraryDynamicsPage',
      method: 'post',
      data: data
    })
  }


  // 获取推荐读书
export function listRecommendReadBooksPage(data) {
    return request({
      url: '/app/study/listRecommendReadBooksPage',
      method: 'post',
      data: data
    })
  }

  // 获取本馆介绍
  export function getLibraryArticle(id) {
    return request({
      url: '/app/study/getLibraryArticle/'+id,
      method: 'get'
    })
  }

  // 获取首页图片
  export function getLibraryImage(data) {
    return request({
      url: '/app/study/getLibraryImage',
      method: 'post',
      data: data
    })
  }


// 获取宣传视频
export function getLibraryVideo(data) {
    return request({
        url: '/app/study/getLibraryVideo',
        method: 'post',
        data: data
    })
}

// 获取问卷二维码
export function getQuestionnaireQrCodeById(id) {
    return request({
        url: '/app/study/getQuestionnaireQrCodeById/' + id,
        method: 'get'
    })
}


// 获取图书排行 菏泽才有
export function getBookRanking(day) {
  return request({
      url: '/app/bookRanking/getBookRanking/' + day,
      method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/study.js